import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Flex, Loading, theme } from '../../../ui';
import { useClassroom } from '../hooks';
import ClassroomSidebar from './ClassroomSidebar';
import ClassroomHeader from './ClassroomHeader';
import ClassroomCalendar from './ClassroomCalendar';
import ChannelView from './ChannelView';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

const MainArea = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

const ContentArea = styled.div`
  flex: 1;
  overflow-y: auto;
  background: ${theme.colors.NEU_50};
`;

const CenteredLoading = styled(Flex)`
  height: 100%;
  width: 100%;
`;

const ClassroomView = ({ groupId }) => {
  const { sectionId: urlSectionId } = useParams();
  const { group, courseDetail, members, sections, isLoading, courseId, isDemo } = useClassroom(groupId);
  const [showCalendar, setShowCalendar] = useState(false);
  const [activeSectionId, setActiveSectionId] = useState(urlSectionId || null);

  // Auto-select first section if none selected
  const currentSectionId = activeSectionId || sections?.[0]?.id;
  const currentSection = sections?.find((s) => s.id === currentSectionId);

  if (isLoading) {
    return (
      <CenteredLoading align='center' justify='center'>
        <Loading />
      </CenteredLoading>
    );
  }

  return (
    <Container>
      <ClassroomHeader
        classroomName={group?.name || 'Classroom'}
        memberCount={members?.length ?? 0}
        showCalendar={showCalendar}
        onToggleCalendar={() => setShowCalendar(!showCalendar)}
      />
      <MainArea>
        <ClassroomSidebar
          sections={sections}
          activeSectionId={currentSectionId}
          onSelectSection={setActiveSectionId}
          members={members}
          onShowCalendar={() => setShowCalendar(true)}
        />
        <ContentArea>
          {showCalendar ? (
            <ClassroomCalendar groupId={groupId} />
          ) : currentSection ? (
            <ChannelView section={currentSection} courseId={courseId} groupId={groupId} isDemo={isDemo} members={members} />
          ) : (
            <CenteredLoading align='center' justify='center'>
              <Loading />
            </CenteredLoading>
          )}
        </ContentArea>
      </MainArea>
    </Container>
  );
};

export default ClassroomView;
